import { SocialHistoryOptionData } from "../../../../../../../../queries/history/social-history/use-get-social-history-questions";
import { Box } from "@mui/material";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
// import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { DEFAULT_FONTSIZE } from "../../../../../../../../utils/utils";
import {
  SOCIAL_HISTORY_QUESTION_ENUM_LIST,
  SOCIAL_HISTORY_QUESTION_TYPES_MAPPER,
} from "../history-constant";
import Text from "../../../../../../../../components/Text";
import { SOCIAL_HISTORY_COLORS } from "../../../../../../../../utils/util.standardized";
// import { formatDateTime } from "../../../../../../../../utils/date-time-utility";
interface Props {
  questions: SocialHistoryOptionData[] | any;
  setSelectedCard: any;
  selectedCard:
    | {
        cardId: string;
        cardIndex: number;
      }
    | undefined;
}

const SocialHistoryCard = (props: Props) => {
  const {
    //  questions,
    setSelectedCard,
    selectedCard,
  } = props;

  const updateId = (newId: string, index: number) => {
    if (newId !== selectedCard?.cardId) {
      setSelectedCard({
        cardId: newId,
        cardIndex: index,
      });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        p: 1,
        minWidth: "249px",
      }}
    >
      {SOCIAL_HISTORY_QUESTION_ENUM_LIST?.map((k, idx: number) => {
        const isSelected = k === selectedCard?.cardId;
        return (
          <Box
            key={k}
            sx={{
              px: 2.5,
              py: 1,
              border: `1px solid ${SOCIAL_HISTORY_COLORS.CARD_BORDER}`,
              borderRadius: "999px",
              cursor: "pointer",
              backgroundColor: isSelected
                ? SOCIAL_HISTORY_COLORS.CARD_ACTIVE_BG
                : SOCIAL_HISTORY_COLORS.CARD_INACTIVE_BG,
              color: isSelected
                ? "#fff"
                : SOCIAL_HISTORY_COLORS.CARD_INACTIVE_TEXT,
              "&:hover": {
                backgroundColor: isSelected
                  ? SOCIAL_HISTORY_COLORS.CARD_ACTIVE_HOVER
                  : SOCIAL_HISTORY_COLORS.CARD_INACTIVE_HOVER,
              },
            }}
            onClick={() => {
              updateId(k, idx);
            }}
          >
            <Text
              sx={{
                ...DEFAULT_FONTSIZE,
                fontWeight: 400,
                whiteSpace: "nowrap",
                fontSize: "12px",
              }}
            >
              {SOCIAL_HISTORY_QUESTION_TYPES_MAPPER[k]}
            </Text>
          </Box>
        );
      })}
    </Box>
  );
};

export default SocialHistoryCard;
